// src/config/accueil.config.ts — SCE Issues
// Accueil personnalisable (chantier du 03/11, docs/chantier-accueil.md) : qui peut
// ranger son accueil et régler ses files.
//
// En essai chez l'administrateur seul (décision de Guillaume) : l'interrupteur
// « Accueil personnalisable » de /admin › Ouvertures l'ouvre à tous. Fermé, les
// autres gardent l'accueil du code, exactement celui d'avant le chantier.

import { rolesCharges } from './registreRoles'
import { estAdmin } from './admin.config'

/** Valeur du code, tant que le panneau n'a rien enregistré : fermé (essai). */
export const ACCUEIL_PERSO_OUVERT_DEFAUT = false

/** L'interrupteur du panneau, sinon la valeur d'ici. */
export function accueilPersoOuvert(): boolean {
  return rolesCharges()?.ouvertures.accueilPerso ?? ACCUEIL_PERSO_OUVERT_DEFAUT
}

/**
 * La personne (AFFICHÉE : en bascule de rôle, celle qu'on regarde) a-t-elle un
 * accueil à elle ? Sinon, celui du code, sans rien lire.
 */
export function accueilPersonnalisable(upn: string | null | undefined): boolean {
  if (!upn) return false
  return estAdmin(upn) || accueilPersoOuvert()
}
